const container = {
  height: '100%',
  gap: '12px',
  padding: '16px 16px 16px 16px',
}

const breadcrumbsStyles = {
  '.MuiBreadcrumbs-root': {
    '.MuiBreadcrumbs-ol': {
      '.MuiBreadcrumbs-li': {
        'a.MuiLink-root': {
          fontSize: { md: '14px', lg: '15px', xl: '16px' },
        },
      },
    },
  },
}

const Loader = {
  width: '100%',
  transform: 'translateX(-21px)',
  position: 'absolute',
  zIndex: 10,
}

const LoaderOverlay = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  transform: 'translateX(-21px)',
  zIndex: 9,
}

const styles = { container, breadcrumbsStyles, Loader, LoaderOverlay }

export default styles
